module.exports = __webpack_public_path__ + "static/media/txt.fdd2c732.svg";